import cx from 'classnames';
import React from 'react';
import styles from './loader-contextual.module.scss';

export type LoaderColors = 'blue' | 'darkgray' | 'gray' | 'white';

export interface LoaderContextualProps {
  /**
   * loader color
   * @default 'blue'
   */
  loaderColor?: LoaderColors;
  /**
   * show / hide the loader
   * @default false
   */
  hideLoader?: boolean;
  /**
   * class name for the loader
   */
  className?: string;
  /**
   * id for the spinner
   */
  id?: string;
}

export const LoaderContextual: React.FC<LoaderContextualProps> = ({
  loaderColor = 'blue',
  hideLoader = false,
  className,
  id,
  ...restProps
}: LoaderContextualProps) => {
  const spinnerClassNames = cx(
    styles.loadingSpinner,
    styles[loaderColor],
    {
      [styles.hideLoader]: hideLoader,
    },
    className
  );

  return <div className={spinnerClassNames} id={id} {...restProps} />;
};
